// extracted by mini-css-extract-plugin
module.exports = {"teckStack_root":"TechStack_teckStack_root__2x3ue","techstack":"TechStack_techstack__15R9g","techstack__items":"TechStack_techstack__items__1YuEk"};